import axios from 'axios'
import { API_URL } from '../config/config'
import { useContext, useState } from 'react'
import { LoaderContext } from '../context/loader-context'
import { EndSessionTimerContext } from '../context/end-session-timer-context'

export default () => {
    const [isInProgress, setIsInProgress] = useState(false)
    const { showloader } = useContext(LoaderContext)
    const { StartTimer, TimerIsShow, EndTimer } = useContext(EndSessionTimerContext)

    const getToken = clientId => axios.get(`${API_URL}/api/auth/retakeToken`, {headers: {Authorization: `Bearer ${localStorage.getItem(`${clientId}_token`)}`, 'X-Client-Id': clientId}})

    function checkExaparedIn() {
        if (isInProgress) return
        const clientId = sessionStorage.getItem('clientId') || localStorage.getItem('clientId')
        if (!clientId) return
        const expirationDateValue = localStorage.getItem(`${clientId}_expirationDate`)
        if (!expirationDateValue) return
        const expiredIn = new Date(expirationDateValue)
        const expiredInIsValid = !Number.isNaN(expiredIn.valueOf())
        if (!expiredInIsValid) return
        const now = new Date()
        const remainingTime = (expiredIn - now) / 60000
        if (remainingTime <= 0) return
        if (remainingTime < 3 && !TimerIsShow && !showloader) StartTimer(expiredIn - now)
        if (remainingTime >= 4) return
        setIsInProgress(true)
        return getToken(clientId)
            .then(res => {
                const newToken = res?.data?.token
                if (!newToken) {
                    throw new Error('Backend nie zwrócił nowego tokena')
                }
                const newExpirationDate = new Date(
                    Date.now() + 1000 * 60 * 60 * 12
                )
                localStorage.setItem(`${clientId}_token`, newToken)
                localStorage.setItem(`${clientId}_expirationDate`, newExpirationDate.toISOString())
                EndTimer()
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setIsInProgress(false)
            })
    }
    return { checkExaparedIn, isInProgress}
}